import React, { Component } from 'react'
import { Button, Form, Input, Select, message, Spin, DatePicker, Checkbox, Upload, Icon, Radio, InputNumber, Switch } from 'antd'
import NumberFormat from 'react-number-format'
import {connect} from 'dva'
import { all, create, get } from '../../services/restApi'
import PropTypes from 'prop-types'
import moment from 'moment'
import config from '../../utils/config'
import { createPassword } from '../../utils'
var IconAwesome = require('react-fontawesome');
const _ = require('underscore')

const FormItem = Form.Item;
const Option = Select.Option;
const TextArea = Input.TextArea;
const MonthPicker = DatePicker.MonthPicker;
const RadioGroup = Radio.Group;

class IncomeNew extends Component {

    constructor (props) {
        super(props);

        this.state = {
            loading: false,
            categories: [],
            discounts: [{objectId: createPassword(), pax: 1, discount: 0}],
            filterByHotel: '',
            imageUrl: '',
            file: {}
        }

        if (localStorage.getItem('currentHotel') && JSON.parse(localStorage.getItem('currentHotel')).objectId) 
            this.state = {...this.state, currentHotel: JSON.parse(localStorage.getItem('currentHotel'))};

        if (this.props.incomeType === 'cash_funds_trie' || this.props.incomeType === 'others_trie' || this.props.incomeType === 'payroll_trie')
            this.state = {...this.state, currentHotel: null};

        message.config({top: 110, duration: 4});
    }


    /**
    * Inicializa los valores, según si se está creando o editando un registro
    */
    componentDidMount () {

        // Query Hotel
        let queryHotel = {};
        this.state.currentHotel ? queryHotel.objectId = this.state.currentHotel.objectId : null;

        // Consulta las categorías principales del hotel asignado al gerente o recepcionista
        all('Category', {
            include: 'companies',
            limit: 100
        }).then((resp) => {
            this.setState({ categories: resp.results });

            if (this.props.activityId)
                this.getIncome();
        })
    }


    /**
    * Obtiene la información del registro
    */
    getIncome () {
        this.props.dispatch({type: 'app/showLoadingTable'})
        get('Activity', this.props.activityId, {include: 'createdBy,category,category.companies'}).then((resp) => {

            if (resp.category) resp.category = {key: resp.category.objectId, label: resp.category.name};
            if (resp.hasDiscount) this.state.discounts = resp.discounts;
            
            this.props.form.setFieldsValue(resp);
            this.props.dispatch({type: 'app/hideLoadingTable'})
        })
    }


    getBase64 (img, callback) {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result));
        reader.readAsDataURL(img);
    }

    beforeUpload (file) {
        const isJPEG = file.type === 'image/jpeg';
        const isJPG = file.type === 'image/jpg';
        const isPNG = file.type === 'image/png';
        if (!isJPG && !isJPEG && !isPNG) {
            message.error('El formato de la imagen is inválido!');
        }

        const isLt2M = file.size / 1024 / 1024 < 5;
        if (!isLt2M) {
            message.error('La imagen debe ser menor a 5MB!');
        }

        this.setState({file: file, loading: true});
        return (isJPG || isJPEG || isPNG) && isLt2M;
    }

    handleChange (info) {
        if (info.file.status === 'done') {
            this.getBase64(info.file.originFileObj, imageUrl => this.setState({ imageUrl }));
            this.setState({loading: false});
        }
    }


    /**
    * Validator: Checa que se haya elegido un hotel de la lista
    */
    checkHotel (rule, value, callback) {
        if (value && !value.label) {
            callback('Por favor, elija el hotel al que pertenece el cliente!');
        } else {
            callback();
        }
    }


    /**
    * Encuentra las coincidencias según la cadena del input Hotel
    */
    fetchExpenseTypes (value, callback) {
        // Query
        let query = {name: {$regex: '(?i)' + value}, type: 'principal'};
        if (this.state.currentHotel)
            query.hotel = {__type: 'Pointer', className: 'TourCompany', objectId: this.state.currentHotel.objectId}

        if (this.state.filterByHotel)
            query.hotel = {__type: 'Pointer', className: 'TourCompany', objectId: this.state.filterByHotel}

        setTimeout(() => {
            if (this.props.incomeType !== 'payments') {
                all('ExpenseType', {where: query}).then((d) => {
                    const results = d.results;
                    callback(results);

                }).catch(e => {
                    message.error('No hemos podido consultar los registros del hotel seleccionado. Intente de nuevo')    
                });

            } else {
                all('PaymentType', {where: query}).then((d) => {
                    const results = d.results;
                    callback(results);

                }).catch(e => {
                    message.error('No hemos podido consultar los registros del hotel seleccionado. Intente de nuevo')    
                });
            }
        }, 500);
    }


    /**
    * Asigna los nuevos valores traidos de la consulta de coincidencias
    */
    handleSelectExpenseTypeChange (value) {
        if (value && value.key && !value.label) {
            this.fetchExpenseTypes(value.key, (resp) => {
                this.setState({ expense_types: resp })
            });
        }
    }


    /**
    * Validator: Checa que se haya elegido un ExpenseType de la lista
    */
    checkExpenseType (rule, value, callback) {
        if (value && !value.label) {
            callback('Por favor, elija el tipo de movimiento');

        } else if (value) {
            let expenseSelected = _.find(this.state.expense_types, {objectId: value.key});

            if (this.props.incomeType !== 'payments') {
                all('ExpenseType', {
                    where: {
                        parent_category: {__type: 'Pointer', className: 'ExpenseType', objectId: expenseSelected.objectId}
                    },
                    limit: 1000
                }).then((d) => {
                    expenseSelected.children = d.results;
                    this.setState({ 
                        expense_selected: expenseSelected,
                        subexpense_selected: null
                    });
                });
            } else {
                all('PaymentType', {
                    where: {
                        parent_category: {__type: 'Pointer', className: 'PaymentType', objectId: expenseSelected.objectId}
                    },
                    limit: 1000
                }).then((d) => {
                    expenseSelected.children = d.results;
                    this.setState({ 
                        expense_selected: expenseSelected,
                        subexpense_selected: null
                    });
                });
            }

            callback();
        } else {
            callback();
        }
    }


    /**
    * Validator: Checa que se haya elegido un Sub Expense de la lista
    */
    checkSubExpenseType (rule, value, callback) {
        if (value && !value.label) {
            callback('Por favor, elija el movimiento');

        } else if (value) {
            let subExpenseSelected = _.find(this.state.expense_selected.children, {objectId: value.key});
            this.setState({ subexpense_selected: subExpenseSelected });

            callback();
        } else {
            callback();
        }
    }


    /**
    * Encuentra las coincidencias según la cadena del input Hotel
    */
    fetchCompany (value, callback) {
        setTimeout(() => {
            all('TourCompany', {where: {name: {$regex: '(?i)' + value}}}).then((d) => {
                const results = d.results;
                const companies = [];
                
                results.forEach((r) => {
                    companies.push({
                        objectId: r.objectId,
                        name: r.name,
                    });
                });

                callback(companies);
            });
        }, 500);
    }


    /**
    * Asigna los nuevos valores traidos de la consulta de coincidencias
    */
    handleSelectCompanyChange (value) {
        if (value && value.key && !value.label) {
            this.fetchCompany(value.key, (resp) => {
                this.setState({ companies: resp })
            });
        }
    }


    /**
    * Encuentra las coincidencias según la cadena del input Categoría (Adon principal)
    */
    fetchCategory (value, callback) {

        let query = {name: {$regex: '(?i)' + value}};

        setTimeout(() => {
            all('Category', {where: query, include: 'companies'}).then((d) => {
                const results = d.results;
                const categories = [];
                
                results.forEach((r) => {
                    categories.push({
                        objectId: r.objectId,
                        name: r.name,
                    });
                });

                callback(categories);
            });
        }, 500);
    }


    /**
    * Asigna los nuevos valores traidos de la consulta de coincidencias
    */
    handleSelectCategoryChange (value) {
        if (value && value.key && !value.label) {
            this.fetchCategory(value.key, (resp) => {
                this.setState({ categories: resp })
            });
        }
    }


    /**
    * Validator: Checa que se haya elegido un adon principal de la lista
    */
    checkType (rule, value, callback) {
        if (value && !value.label) {
            callback('Por favor, elija la categoría!');
        } else {
            callback();
        }
    }


    /**
    * Validator: Checa que el monto sea mayor a 0
    */
    checkAmount (rule, value, callback) {
        if (value && !_.isNumber(value) && Number(value.replace(/[^\d.-]/g, '')) === 0) {
            callback('Por favor, ingrese un monto correcto!');
        } else {
            callback();
        }
    } 


    /**
    * Envío del formulario
    */
    handleSubmit (e) {
        e.preventDefault();

        this.props.form.validateFieldsAndScroll((errors, values) => {
            if (errors) { return }

            // Model
            let data = {};
            data.name = values.name;
            data.price = values.price;
            data.description = values.description;
            data.createdBy = {__type: 'Pointer', className: '_User', objectId: this.props.app.user.objectId};
            data.category = {__type: 'Pointer', className: 'Category', objectId: values.category.key};
            values.hasDiscount ? data.hasDiscount = true : data.hasDiscount = false;
            data.discounts = [];
            values.active ? data.active = values.active : data.active = true;

            this.state.discounts.map(item => {
                let discount = {};
                discount.objectId = item.objectId;

                values[discount.objectId + '_pax'] ? discount.pax = values[discount.objectId + '_pax'] : discount.pax = 0;
                values[discount.objectId + '_discount'] ? discount.discount = values[discount.objectId + '_discount'] : discount.discount = 0;

                data.discounts.push(discount);
            })

            if (this.state.file.uid) 
                data.picture = this.state.file.uid + '.jpg';

            if (values.price)
                _.isNumber(values.price) ? data.price = values.price : data.price = Number(values.price.replace(/[^\d.]/g, ''))
            else
                data.price = 0;

            
            if (!this.props.activityId) {
                // CREA

                data.active = true;
                
                this.props.dispatch({type: 'app/showButtonLoading'})

                create('Activity', data).then(resp => {

                    _.extend(data, resp);
                    data.category = _.find(this.state.categories, {objectId: data.category.objectId});
                    data.createdBy = this.props.app.user;

                    this.props.dispatch({type: 'app/hideButtonLoading'})
                    message.success('Se ha creado el registro exitosamente');

                    this.props.dispatch({type: 'activity/createSuccess', payload: data})
                    this.props.form.resetFields();

                }).catch(e => {
                    this.props.dispatch({type: 'app/hideButtonLoading'})

                    if (e && e.data) message.error(e.data.error);
                    else message.error('Ha ocurrido un error. Intente más tarde')    
                });

            } else {
                // ACTUALIZA

                data.objectId = this.props.activityId;
                this.props.dispatch({type: 'activity/update', payload: data})
            }
        })
    }


    /**
    * Render del componente
    */
    render () {
        const category_options = this.state.categories.map(d => <Option key={d.objectId} label={d.name}>{d.name}</Option>)

        return (
            <div>
                <Form onSubmit={this.handleSubmit.bind(this)}>
                    <Spin spinning={this.props.app.loadingTable}>
                        <div className="row">
                            {/*<div className="col-md-3">
                                <label>Imagen destacada</label>
                                <Upload
                                    className="avatar-uploader"
                                    name="file"
                                    accept="image/*"
                                    showUploadList={true}
                                    action={config.externalUrl + "includes/upload.php"}
                                    beforeUpload={this.beforeUpload.bind(this)}
                                    onChange={this.handleChange.bind(this)}
                                    headers={{
                                        "X-Parse-Application-Id": config.appId
                                    }}
                                    data={{
                                        type: 'activity',
                                        custom_name: this.state.file.uid + '.jpg'
                                    }}
                                >
                                    {this.state.imageUrl ?
                                        <img src={this.state.imageUrl} alt="" className="avatar" /> :
                                        this.state.loading ? 
                                            <IconAwesome name="refresh" spin className="spin-uploader" />
                                            : <Icon type="plus" className="avatar-uploader-trigger" />
                                    }
                                </Upload>
                            </div>*/}

                            {this.props.activityId
                                ? <div className="col-md-12">
                                    Status: <FormItem hasFeedback>
                                        {this.props.form.getFieldDecorator('active')(
                                            <Switch checkedChildren={<Icon type="check" />} unCheckedChildren={<Icon type="cross" />} checked={this.props.form.getFieldValue('active')} />
                                        )}
                                    </FormItem>
                                </div>
                                : ''
                            }

                            <div className="col-md-4">
                                <FormItem label="Categoría" hasFeedback>
                                    {this.props.form.getFieldDecorator('category', {
                                        rules: [{
                                            required: true,
                                            message: 'Por favor, elija la categoría',
                                        }, {
                                            validator: this.checkType.bind(this)
                                        }]
                                    })(
                                        <Select 
                                            size='large'
                                            mode="combobox"
                                            onChange={this.handleSelectCategoryChange.bind(this)}
                                            filterOption={false}
                                            labelInValue={true}
                                            optionLabelProp='label'
                                            >
                                            {category_options}
                                        </Select>
                                    )}
                                </FormItem>
                            </div>

                            <div className="col-md-4">
                                <FormItem label="Nombre" hasFeedback>
                                    {this.props.form.getFieldDecorator('name', {
                                        rules: [{
                                            required: true,
                                            message: 'Por favor, ingrese el nombre de la actividad'
                                        }]
                                    })(<Input size='large' />)}
                                </FormItem>
                            </div>

                            <div className="col-md-4">
                                <FormItem label="Precio por persona" hasFeedback>
                                    {this.props.form.getFieldDecorator('price', {
                                        rules: [{
                                            required: true,
                                            message: 'Ingrese el precio de la actividad',
                                        }, {
                                            validator: this.checkAmount.bind(this)
                                        }]
                                    })(
                                        <NumberFormat 
                                            thousandSeparator={true} 
                                            prefix={'$'} 
                                            className="ant-input ant-input-lg" />
                                    )}
                                </FormItem>
                            </div>

                            <div className="col-md-12">
                                <FormItem label="Breve descripción" hasFeedback>
                                    {this.props.form.getFieldDecorator('description')(<TextArea rows={3} />)}
                                </FormItem>
                            </div>

                            <div className="col-md-12">
                                <FormItem style={{marginTop: '-10px', marginBottom: '0'}}>
                                    {this.props.form.getFieldDecorator('hasDiscount')(
                                        <Checkbox checked={this.props.form.getFieldValue('hasDiscount') ? this.props.form.getFieldValue('hasDiscount') : false}>Gestionar descuentos</Checkbox>
                                    )}
                                </FormItem>
                            </div>

                            {this.props.form.getFieldValue('hasDiscount') && this.state.discounts.map(item => (
                                <div key={item.objectId}>
                                    <div className="col-md-3">
                                        <FormItem label="PAX a partir de" hasFeedback>
                                            {this.props.form.getFieldDecorator(item.objectId + '_pax', {
                                                initialValue: item.pax
                                            })(
                                                <InputNumber
                                                    min={1}
                                                    max={100}
                                                    className="ant-input ant-input-lg"
                                                />
                                            )}
                                        </FormItem>
                                    </div>

                                    <div className="col-md-3">
                                        <FormItem label="% Descuento aplicado" hasFeedback>
                                            {this.props.form.getFieldDecorator(item.objectId + '_discount', {
                                                initialValue: item.discount
                                            })(
                                                <InputNumber
                                                    min={0}
                                                    max={100}
                                                    formatter={value => `${value}%`}
                                                    parser={value => value.replace('%', '')}
                                                    className="ant-input ant-input-lg"
                                                />
                                            )}
                                        </FormItem>
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div className="row text-center">
                            <Button type='primary' onClick={this.handleSubmit.bind(this)} loading={this.props.app.buttonLoading} className={'btn btn-primary btn-flat'}>
                                Guardar
                            </Button>
                        </div>
                    </Spin>
                </Form>
            </div>
        )
    }
}

IncomeNew.contextTypes = {
    router: PropTypes.object.isRequired
}

export default connect(({income, app}) => ({income, app}))(Form.create()(IncomeNew))


// WEBPACK FOOTER //
// ./src/components/activities/activityNew.js